// Packages
import axios from "axios";
import Cookies from "js-cookie";

// Components
import { setAuthToken } from "../utils/auth";
import { axiosInstance } from "..";
import { API_URL } from "../utils/consts";
import { useEffect, useState } from "react";

axios.defaults.baseURL = API_URL;


export const checkUserExistApi = async (formData: FormData) => {
    const response = await axios.post("api/checkUserExists", formData);

    if (response.status === 200 && response.data.message === "Email Registered") {
        return response.data.message;
    }

    return response.data;
}

export const sendVerifyMsgApi = async (phoneNumber: string) => {
    const response = await axiosInstance.post("api/sendVerifyMsg", {
        phone: phoneNumber
    });
    return response;
}

export const verifyRegisterApi = async (phoneNumber: string, code:string) => {
    const response = await axiosInstance.post("api/verifyRegister", {
        phone: phoneNumber, otp:code
    });
    return response;
}

export const generateOTPApi = async (username: string) => {
    const response = await axios.post("api/generateOTP", {
        user:username
    });
    return response;
}

export const verifyOTPApi = async (formData: FormData) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
        withCredentials: true,
    };
    const response = await axios.post("api/verifyOTP", formData, config);
    return response;
}

export const loginApi = async (formData: FormData) => {
    // const body = JSON.stringify(formData);
    var csrfCookie = Cookies.get('csrftoken')
    const config = {
        headers: {
            "Content-Type": "application/json",
            'X-CSRFToken': csrfCookie? csrfCookie : 0,
        },
        withCredentials: true,
    };
    const response = await axios.post("api/login", formData, config);
    
    return response
}

export const logoutApi = async() => {
    const config = {
        withCredentials: true
    }
    const response = await axios.get("api/logout", config)
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

export const checkAccessTokenApi = async() => {
    const response = await axiosInstance.get("api/checkAccessToken")
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

export const checkRefreshTokenApi = async() => {
    const response = await axiosInstance.get("api/checkRefreshToken")
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

export const refreshTokenApi = async(payload: any) => {
    var csrfCookie = Cookies.get('csrftoken')
    const config = {
        headers: {
            'X-CSRFToken': csrfCookie? csrfCookie : 0
        },
        withCredentials: true
    }
    const response = await axios.post("api/refreshToken", payload, config)
    if (response.status !== 200) {
        return null;
    }
    return response.data
}

export const CSRFToken = () => {
    const [csrfToken, setCSRFToken] = useState('')
    const [isLoading, setLoading] = useState(true);

    const getCookie = (name: string) => {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            let cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const config = {
                    withCredentials: true
                }
                const response = await axios.get("api/getCSRFToken", config);

                if (response) {
                    const token = getCookie('csrftoken')
                    if (token) {
                        setCSRFToken(token);
                        setLoading(false)
                    }
                }
            } catch (err) {
            }
        };
        fetchData();
    }, []);

    if (isLoading) {
        return <div></div>
    }

    return (
        <input type='hidden' name='csrfmiddlewaretoken' value={csrfToken} />
    );
};